import { Button } from "@rio-cloud/rio-uikit";
import Dialog from "@rio-cloud/rio-uikit/Dialog";
import { useEffect, useState } from "react";
import { useT } from "@hooks";

interface Props {
  show: boolean;
  onClose: () => void;
  onSave: (value: string, selectCategory?: string, selectType?: string) => void;
  title: string;
  placeholder: string;
  name?: string;
}

const DialogEditCategorySetttings = ({ show, onClose, onSave, title, placeholder, name }: Props) => {
  const t = useT();
  const [error, setError] = useState("");

  const [valueCategory, setValueCategory] = useState(name || "");

  useEffect(() => {
    setValueCategory(name ?? "");
  }, [name, show]);

  const handleSubmit = () => {
    if (!valueCategory) {
      setError(t("common.label.requiredField"));
      return;
    }

    setError("");

    setValueCategory("");
    onSave(valueCategory);
  };

  const handleClose = () => {
    onClose();
    setValueCategory("");
    setError("");
  };

  return (
    <Dialog
      show={show}
      title={<span className="text-medium text-size-16">{title}</span>}
      body={
        <div className={`form-group ${error ? "has-feedback has-error" : ""}`}>
          <label htmlFor="inputValue">
            <span>{placeholder}</span>
          </label>
          <div className="input-group">
            <input
              id="inputValue"
              type="text"
              className="form-control"
              value={valueCategory}
              onChange={(e) => setValueCategory(e.target.value)}
              name="value"
            />
          </div>
          {error ? <span className="form-control-feedback rioglyph rioglyph-error-sign"></span> : null}
          <span className="help-block">
            <span>{error}</span>
          </span>
        </div>
      }
      onClose={handleClose}
      footer={
        <div className="display-flex align-items-center justify-content-end gap-10 flex-wrap">
          <Button onClick={handleClose} className="width-150 rounded-small width-100pct-xs">
            {t("common.action.cancel")}
          </Button>
          <Button onClick={handleSubmit} bsStyle={Button.PRIMARY} className="width-150 rounded-small width-100pct-xs">
            {t("common.action.save")}
          </Button>
        </div>
      }
      showCloseButton
    />
  );
};

export default DialogEditCategorySetttings;
